import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {MenyTjeneste} from "../../../../komponenter/meny/meny";

const css = require('./ikkePublisertTips.scss');

export class IkkePublisertTips implements IController {

    static skjultTipsRegister: { [møteId: string]: boolean } = {};

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteIkkePublisertTips', {
                bindings: {moete: '<', vedPubliserMoete: '&', vedPubliserProtokoll: '&'},
                controller: IkkePublisertTips.forInjisering(),
                template: require('./ikkePublisertTips.html')
            });
    }

    static forInjisering() {
        return [
            MenyTjeneste.regNavn,
            Kontekst.regNavn,
            IkkePublisertTips
        ]
    }

    constructor(private menyTjeneste:MenyTjeneste, private kontekst: Kontekst) {
    }

    moete: l.MøteModell; //settes via bindings/$onChanges
    vedPubliserMoete: (arg: { moete: l.MøteModell; }) => any; //settes via bindings/$onChanges
    vedPubliserProtokoll: (arg: { moete: l.MøteModell; }) => any; //settes via bindings/$onChanges

    redigeringMulig = false;
    modus: 'moeteIkkePublisert' | 'moeteIkkePublisertMenTilgang' | 'protokollIkkePublisert' | 'protokollIkkePublisertMenTilgang' = null;

    tipsVises() {
        return this.moete &&
            IkkePublisertTips.skjultTipsRegister[this.moete.id] !== true
            && this.modus != null
            && this.menyTjeneste.erAktivert();
    }

    skjuTips() {
        IkkePublisertTips.skjultTipsRegister[this.moete.id] = true;
    }

    publiserMoete() {
        this.vedPubliserMoete({moete: this.moete});
    }

    publiserProtokoll() {
        this.vedPubliserProtokoll({moete: this.moete});
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'moete', møte => this.initMøte(møte));
    }

    //hjelpemetoder

    private initMøte(møte: l.MøteModell) {
        this.moete = møte;
        this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.moete.eiendeGruppeId);

        const tilgangTilIkkepublisert = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.moete.eiendeGruppeId) ||
          this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.tilgangIkkePublisert, this.moete.eiendeGruppeId);

        if (!møte.tilgang.erMoetePublisert && !tilgangTilIkkepublisert)
            this.modus = 'moeteIkkePublisert';
        else if (!møte.tilgang.erMoetePublisert && tilgangTilIkkepublisert)
            this.modus = 'moeteIkkePublisertMenTilgang';
        else if (!møte.tilgang.erProtokollPublisert && !tilgangTilIkkepublisert)
            this.modus = 'protokollIkkePublisert';
        else if (!møte.tilgang.erProtokollPublisert && tilgangTilIkkepublisert)
            this.modus = 'protokollIkkePublisertMenTilgang';
        else
            this.modus = null;
    }
}
